import { APIMethod, fetchData } from "@client";

export async function updateUserInfoQuery(data) {
  const res = await fetchData("/user/edit", APIMethod.POST, { data });
  return res.user;
}
